<template>
  <v-container>
    <h1 class="page-heading">System Vitals</h1>
  </v-container>
  <v-container v-if="!userHasAccess">
    <RequestAccess
      desc_text="Would you like to view the health of your solar setup in real-time?"
      button_text="Yes, show me the stats"
      alt_text="I need to install solar panels"
      :feature_name="featureName"
    />
  </v-container>
  <v-container v-else>
    <v-row>
      <v-col>
        <!-- <h2 class="text font-medium">Electricity generated</h2> -->
        <Line
          :chart-options="chartOptions"
          :chart-data="chartData"
          :chart-id="chartId"
          :dataset-id-key="datasetIdKey"
          :plugins="plugins"
          :css-classes="cssClasses"
          :styles="styles"
          width="10px"
          ref="myLinechart"
        />
      </v-col>
      <v-col>
        <div class="vitals__summary ml-10 rounded-xl">
          <p class="subtitle mb-4">Today's Vitals</p>

          <div class="vitals__item">
            <p class="text-sm font-medium">Electricity consumed</p>
            <p class="title font-thick font-green">{{ elecConsumed }} kWh</p>
          </div>
          <div class="vitals__item">
            <p class="text-sm font-medium">Electricity generated</p>
            <p class="title font-thick font-green">{{ elecGenerated }} kWh</p>
          </div>
          <div class="vitals__item mb-5">
            <p class="text-sm font-medium">Money saved</p>
            <p class="title font-thick font-green">RM {{ moneySaved }}</p>
          </div>
          <!-- <div class="vitals__tabs">
                        <v-tabs color="#7ccb6f">
                            <v-tab>Today</v-tab>
                            <v-tab>This Week</v-tab>
                            <v-tab>This Month</v-tab>
                        </v-tabs>
                    </div> -->
          <div class="vitals__action">
            <SolidButton
              text="Request Maintenance"
              to="request-maintenance"
              class="mt-3"
            />
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          style="background-color: #ffdf8c"
          elevation="2"
          outlined
          shaped
          tile
          class="my-12 rounded-xl"
        >
          <v-container fluid>
            <v-row>
              <v-col>
                <v-card-text class="text font-medium">
                  Actual vs Predicted Power Output</v-card-text
                >
              </v-col>
              <v-col>
                <v-card style="background-color: white" class="rounded-pill">
                  <v-card-text align="center" class="text font-thin">
                    98%
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card-text class="text font-medium">
                  Condition of Solar Panel</v-card-text
                >
              </v-col>
              <v-col>
                <v-card style="background-color: white" class="rounded-pill">
                  <v-card-text align="center" class="text font-thin">
                    Good
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <h3 class="text font-thin">Carbon footprint reduced</h3>
        <h1 class="title font-thick font-green">20x</h1>
      </v-col>
      <v-col>
        <h3 class="text font-thin">Solar Panel Efficiency</h3>
        <h1 class="title font-thick font-green">100%</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import RequestAccess from "@/components/RequestAccess.vue";
import SolidButton from "@/components/SolidButton.vue";
import { computed } from "@vue/runtime-core";
import store from "@/store";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
);
export default {
  name: "SystemVitalsView",

  components: {
    Line,
    RequestAccess,
    SolidButton,
  },
  methods: {
    updateData() {
      if (!this.$refs.myLinechart) {
        return;
      }
      this.$refs.myLinechart.chart.options.animation = false;
      //alert('Updating data...');
      const MAX_ELEC_GEN = 40;
      this.moneySaved =
        parseFloat(this.moneySaved) +
        parseFloat((Math.random() * 0.1).toFixed(2));
      this.moneySaved = this.moneySaved.toFixed(2);

      this.elecGenerated =
        parseFloat(this.elecGenerated) +
        parseFloat((Math.random() * 0.1).toFixed(2));
      this.elecGenerated = this.elecGenerated.toFixed(2);

      this.elecConsumed =
        parseFloat(this.elecConsumed) +
        parseFloat((Math.random() * 0.1).toFixed(2));
      this.elecConsumed = this.elecConsumed.toFixed(2);

      /*const generated = Math.floor(Math.random() * 5) +*/
      /*this.chartData.datasets[1].data[];*/
      const generated = Math.max(
        0,
        this.chartData.datasets[1].data.at(-1) +
          Math.floor(Math.random() * 7) -
          3
      );
      const consumed = Math.max(0, Math.floor(generated - Math.random() * 4));
      this.chartData.datasets[1] = {
        ...this.chartData.datasets[1],
        data: this.chartData.datasets[1].data.slice(1).concat(generated),
      };
      this.chartData.datasets[0] = {
        ...this.chartData.datasets[0],
        data: this.chartData.datasets[0].data.slice(1).concat(consumed),
      };
    },
  },

  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    elecConsumed: 30,
    elecGenerated: 10,
    moneySaved: 15.12,
    chartData: {
      labels: new Array(50).fill(""),
      datasets: [
        {
          label: "Electricity consumed",
          borderColor: "#B155D1",
          data: [
            21, 25, 25, 24, 27, 31, 30, 25, 29, 24, 25, 27, 28, 29, 28, 28, 33,
            28, 24, 28, 27, 28, 29, 30, 27, 23, 22, 24, 18, 17, 13, 12, 15, 13,
            16, 11, 14, 9, 8, 7, 10, 8, 7, 9, 12, 14, 12, 13, 16, 16,
          ],
          pointRadius: 0,
        },
        {
          label: "Electricity generated",
          borderColor: "#7ccb6f",
          data: [
            25, 28, 28, 26, 29, 32, 31, 28, 30, 27, 26, 29, 30, 31, 31, 31, 34,
            31, 28, 30, 30, 30, 31, 31, 28, 25, 26, 25, 22, 20, 17, 14, 17, 15,
            18, 15, 16, 13, 10, 9, 12, 11, 11, 10, 13, 16, 16, 15, 18, 19,
          ],
          pointRadius: 0,
        },
      ],
    },
    chartOptions: {
      responsive: true,
      scales: {
        y: {
          ticks: {
            callback: function (val, index) {
              // Hacky quick workaround to scale the values down
              return (this.getLabelForValue(val) / 45).toFixed(2);
            },
          },
          suggestedMin: 0,
          suggestedMax: 45,
          title: { display: true, text: "Watt Hours" },
        },
        x: {
          stacked: true,
          grid: { display: false },
          title: { display: true, text: "Time (seconds)" },
        },
      },
    },
    counter: 0,
  }),
  mounted() {
    setInterval(this.updateData, 1000);
  },
  setup() {
    const featureName = "System Vitals";
    const userHasAccess = computed(
      () => store.state.user?.features?.includes(featureName) || false
    );
    return {
      featureName,
      userHasAccess,
    };
  },
};
</script>

<style lang="scss">
h1 {
  font-size: 50px;
}
.vitals {
  &__summary {
    border: 3px solid $light-gray;

    display: flex;
    height: 90%;
    flex-direction: column;
    align-items: center;
    padding: 30px;

    box-shadow: -1px 10px 20px -7px rgba(0, 0, 0, 0.26);
    -webkit-box-shadow: -1px 10px 20px -7px rgba(0, 0, 0, 0.26);
    -moz-box-shadow: -1px 10px 20px -7px rgba(0, 0, 0, 0.26);
  }
  &__item {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    p {
      width: 170px;
    }
  }
  &__tabs {
    border-top: 1px solid $dark-gray;
    padding-top: 20px;
  }
}
</style>
